/* eslint-disable xss/no-mixed-html */
/* eslint-disable vars-on-top */
$(document).ready(function() {
  var conqainitpageno = 1,
      conqapager = 1,
      conqamaxpage = parseInt($('#ph-conqamaxseqno').val(), 10),
      conqamaxrdbtn = parseInt($('#ph-conqamaxradiobtn').val(), 10),
      bglight = 'ph-bg-light',
      conqadisablebtn = 'ph-conqabtndisabled ph-btn ph-disabled',
      conqapageindic = 'ph-conqapageindic_',
      wholedivdisplay = 'ph-conqawholedivdisplay_',
      conqayesnotrue = 'ph-conqayesnotrue',
      conqanxtbtn = 'ph-conqanxtbtn_',
      headanswer = '.ph-headans_';


  for (var contqaiteratora = conqainitpageno; contqaiteratora <= conqamaxpage; contqaiteratora = contqaiteratora + 1) {
    $('.ph-conqapageidicouter').append('<div class="ph-flex-fill ' + bglight + ' ph-bg-primary ph-conqapageindicmr ' + conqapageindic +
            contqaiteratora + '"></div>');
  }

  function enableNextButton() {
    if ($('div.ph-conqardbtngrp_' + conqapager + ':not(:has(:radio:checked))').length === 0) {
      $('#' + conqanxtbtn + conqapager).removeClass(conqadisablebtn);
    }
  }

  function conqapageScrollUpfunction() {
    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
  }

  function clickingConqayesButton() {
    $(this).addClass(conqayesnotrue);
    $(this).next().removeClass(conqayesnotrue);

    if ($(this).hasClass('ph-conqaheaderrdbtn')) {
      $(headanswer + conqapager).val('true').prop('checked', true);
      $('#' + conqanxtbtn + conqapager).removeClass(conqadisablebtn);
    } else {
      $(this).next().next().val('true').prop('checked', true);
      enableNextButton();
    }
  }

  function clickingcConqanoButton() {
    $(this).addClass(conqayesnotrue);
    $(this).prev().removeClass(conqayesnotrue);

    if ($(this).hasClass('ph-conqaheaderrdbtn')) {
      $(headanswer + conqapager).val('false').prop('checked', true);
      $('#' + conqanxtbtn + conqapager).removeClass(conqadisablebtn);
    } else {
      $(this).next().val('false').prop('checked', true);
      enableNextButton();
    }
  }

  for (var contqaiterator = conqainitpageno; contqaiterator <= conqamaxrdbtn - 1; contqaiterator = contqaiterator + 1) {
    $('.ph-conqaclickyes_' + contqaiterator).click(clickingConqayesButton);
    $('.ph-conqaclickno_' + contqaiterator).click(clickingcConqanoButton);
  }

  $('.' + wholedivdisplay + conqapager).removeClass('hidden');
  $('.' + conqapageindic + conqapager).removeClass(bglight);

  $(document).on('click', '.ph-conqapageplusfn', function() {
    if (conqapager < conqamaxpage) {
      $('.' + wholedivdisplay + conqapager).addClass('hidden');
      conqapager = conqapager + 1;
      $('.' + wholedivdisplay + conqapager).removeClass('hidden');
      $('.' + conqapageindic + conqapager).removeClass(bglight);
    }

    conqapageScrollUpfunction();
  });


  $(document).on('click', '.ph-conqapageminusfn', function() {
    if (conqainitpageno < conqapager) {
      $('.' + conqapageindic + conqapager).addClass(bglight);
      $('.' + wholedivdisplay + conqapager).addClass('hidden');
      conqapager = conqapager - 1;
      $('.' + wholedivdisplay + conqapager).removeClass('hidden');
    } else {
      $('.ph-contractrenewalquestionpage').hide();
      $('.ph-editcontractdetailspage').show();
    }

    conqapageScrollUpfunction();
  });
});


// Updated changes for pre-populating data
$(document).ready(function() {
  var conqastart = 1,
      conyesnotrue = 'ph-conqayesnotrue',
      radiobtniterator = '.ph-radiobtniterator_',
      headans = '.ph-headans_',
      conqamaxpageno = parseInt($('#ph-conqamaxseqno').val(), 10),
      conqatotalrdbtn = parseInt($('#ph-conqamaxradiobtn').val(), 10);

  if (($('.ph-radiobtniterator_1').val() === 'true') || ($('.ph-radiobtniterator_1').val() === 'false')) {
    for (var btnno = conqastart; btnno <= conqamaxpageno; btnno = btnno + 1) {
      $('#ph-conqanxtbtn_' + btnno).removeClass('ph-conqabtndisabled ph-btn ph-disabled');
    }

    for (var conqaiterate = conqastart; conqaiterate <= conqatotalrdbtn - 1; conqaiterate = conqaiterate + 1) {
      if ($(radiobtniterator + conqaiterate).val() === 'false') {
        $(headans + conqaiterate).val('false').prop('checked', true);
        $(radiobtniterator + conqaiterate).val('false').prop('checked', true);
        $('.ph-conqaclickno_' + conqaiterate).addClass(conyesnotrue);
        $('#ph-conqanobtn_' + conqaiterate).prop('checked', true);
      }

      if ($(radiobtniterator + conqaiterate).val() === 'true') {
        $(headans + conqaiterate).val('true').prop('checked', true);
        $(radiobtniterator + conqaiterate).val('true').prop('checked', true);
        $('.ph-conqaclickyes_' + conqaiterate).addClass(conyesnotrue);
        $('#ph-conqayesbtn_' + conqaiterate).prop('checked', true);
      }
    }
  }
});

// Js changes for contract-summary page
$(document).on('click', '.ph-contsumbtbtnjs', function() {
  $.colorbox({
    maxWidth: '476px',
    width: '95%',
    height: '274px',
    scrolling: false,
    html: $('.ph-contsumconfirmpopup').html(),
    onClosed: function() {
      ACC.common.refreshScreenReaderBuffer();
    }
  });
});

$(document).on('click', '#ph-contractsummary-no', function() {
  $.colorbox.close();
});

ACC.contractrenewalpage = {
  contractMandatoryCheck: function() {
    var endValueAdd = $('.ph-contract-addfield').val(),
        mandatoryValueAdd = '',
        contString = 'ph-contractaddfield';

    for (var counter = 0; counter < endValueAdd; counter = counter + 1) {
      mandatoryValueAdd = $('.ph-contract-mandatory' + counter).val();

      if (mandatoryValueAdd === 'false') {
        $('.' + contString + counter).removeClass('ph-fieldemptydetails');
        $('.' + contString + counter).addClass('ph-fieldemptydetailsadd');
      }
    }
  },
  contractEditBtnCheck: function() {
    var endValue = $('.ph-contract-addfield').val(),
        mandatoryValue = '';

    for (var count = 0; count < endValue; count = count + 1) {
      $('.ph-input-addfield' + count).val($('.ph-contractaddfield' + count).text());
      mandatoryValue = $('.ph-contract-mandatory' + count).val();

      if (mandatoryValue === 'false') {
        $('.ph-contract__addfield' + count).removeClass('ph-inputData');
        $('.ph-contract__addfield' + count).addClass('ph-inputDataadd');
      }
    }
  },
  contractSaveBtnCheck: function(response) {
    var contractString = 'ph-contract-addfield',
        endValue = $('.' + contractString).val();

    for (var count = 0; count < endValue; count = count + 1) {
      $('.ph-contractaddfield' + count).text(response.additionalFieldsList[count].value);
    }
  }
};


/* eslint-enable xss/no-mixed-html */
/* eslint-enable vars-on-top */
